import { isNotEmpty } from "../../utils/validations.utils"
import { DateTime } from "luxon"

export const EVENT_TYPES = {
  PERIOD_START: "periodStart",
  PERIOD_END: "periodEnd",
  HOLIDAY: "holiday",
  VACATION: "vacation",
  DAY_OFF: "day_off",
  GLOBAL_SISU: "globalSisu",
}

export const HOLIDAY_SCHEMAS = {
  MEXICAN: "mexican",
  FOREIGN: "foreign",
}

export const VACATION_HISTORY_APPROVED_STATUS = {
  PENDING: "Pendiente",
  REJECTED: "Rechazada",
  APPROVED: "Aprobada",
  CANCELED: "Cancelada",
}

export const VACATION_SCHEMAS = {
  NATIONAL_2019: "Nacional v2019",
  NATIONAL_2024: "Nacional v2024",
  INTERNATIONAL: "Internacional",
  GLOBAL: "Global",
}

export const VACATION_STATES = /** @type {const} */ ({
  PENDING: "pending",
  APPROVED: "approved",
  APPROVED_AND_PENDING_PLUS_DAYS_PAY_DATE:
    "approved_and_pending_plus_days_pay_date",
  REJECTED: "rejected",
  CANCELED: "canceled",
  CHANGE_REQUEST: "change_request",
  CANCEL_REQUEST: "cancel_request",
  BLOCKED: "blocked",
  PERIOD_START: "period_start",
})

export const MY_VACATION_STATES = /** @type {const} */ ({
  CREATE: "create",
  QUERY: "query",
  CHANGE_PENDING: "change_pending",
  CHANGE_APPROVED: "change_approved",
  CANCEL_APPROVED: "cancel_approved",
})

export const VACATION_STATUS_CHIP_VARIANTS = /** @type {const} */ ({
  SHORT: "short",
  LONG: "long",
})

export const VACATION_DAY_TYPES = /** @type {const} */ ({
  BUCKET: "cubeta",
  PLUS: "dia_plus",
  EXTRA: "dia_extra",
  TAKEN: "dia_tomado",
  ACCORDED: "dia_acordado",
  APROBADOS: "dias_aprobados",
  POR_APROBAR: "dias_por_aprobar",
  PLUS_PENDIENTE_PAGO: "dia_plus_pendiente_pago",
})

export const VACATION_DAY_TYPE_NAMES = {
  BUCKET: "Cubeta",
  PLUS: "Días +",
  ACCORDED: "Adicionales",
  EXTRA: "Libre adicional",
}

export const VACATION_DAY_TYPE_COPYS = {
  BUCKET: "Cubeta",
  PLUS: "Días +",
  ACCORDED: "Acordados",
  EXTRA: "Adicionales",
  POR_APROBAR: "Por aprobar",
  APROBADOS: "Aprobados",
  PLUS_PENDIENTE_PAGO: "Pago pendiente",
}

export const VACATION_STATES_LABELS = /** @type {const} */ ({
  [VACATION_STATES.APPROVED]: "Aprobada",
  [VACATION_STATES.APPROVED_AND_PENDING_PLUS_DAYS_PAY_DATE]: "Pago pendiente",
  [VACATION_STATES.PENDING]: "Pendiente",
  [VACATION_STATES.REJECTED]: "Rechazada",
  [VACATION_STATES.BLOCKED]: "Bloqueada",
  [VACATION_STATES.CANCELED]: "Cancelada",
  [VACATION_STATES.CHANGE_REQUEST]: "Solicitud de cambio",
  [VACATION_STATES.CANCEL_REQUEST]: "Solicitud de cancelación",
  [VACATION_STATES.PERIOD_START]: "Inicio de periodo",
})

export const VACATION_REQUEST_STATUS = {
  NOT_REVIEWED: 0,
  REVIEWED: 1,
}

export const VACATION_APPROVED_STATUS = {
  NOT_REVIEWED: null,
  REJECTED: 0,
  APPROVED: 1,
  CANCELED_BY_ADMIN: 2,
  CANCELED_BY_TEAM_MEMBER: 3,
}

export const VACATION_DAYS_VARIANTS = /** @type {const} */ ({
  SHORT: "short",
  LONG: "long",
})

export const HOLIDAY_TYPES_IDS = {
  OFICIALS: 1,
  PLUS: 2,
  GLOBAL_SISU: 3,
}

export const HOLIDAYS_MODALS_TABS = {
  OFICIALES: "1",
  FERIADOS_PLUS: "2",
  GLOBALES_SISU: "3",
}

export const VACATION_PERIOD_NAVIGATOR_MODES = /** @type {const} */ ({
  MANAGEMENT: "gestion",
  PERIOD: "periodo_ingreso",
  REPORT: "reporte",
  HISTORY: "historial",
  HISTORY_TEAM_MEMBER: "historial_miembro_equipo",
})

export const DEFAULT_NEW_HOLIDAY = { name: "", date: null }

export const TEAM_VACATION_REQUESTS_FILTER_TYPES = /** @type {const} */ ({
  PENDING: "pendientes",
  REQUESTED: "por_tomar",
})

export const TEAM_VACATION_REQUESTS_FILTER_OPTIONS = {
  past_requests: true,
  rejected_requests: true,
}

export const TEAM_VACATION_REQUESTS_SORT_BUTTON_OPTIONS = [
  {
    label: "Pendientes",
    value: TEAM_VACATION_REQUESTS_FILTER_TYPES.PENDING,
  },
  {
    label: "Por tomar",
    value: TEAM_VACATION_REQUESTS_FILTER_TYPES.REQUESTED,
  },
]

/** @type {Record<number, string>} */
export const HOLIDAYS_TYPES_ID_TO_LABEL = {
  1: "mexican",
  2: "mexican",
  3: "global",
  4: "globalSisu",
}

export const HOLIDAYS_SCHEMA_ID_TO_LABEL = {
  1: "mexican",
  2: "foreign",
  3: "global",
}

export const CREATING_MEMBER_HOLIDAY_SCHEMA_ID = {
  NATIONAL_2019: 1,
  NATIONAL_2024: 2,
  INTERNATIONAL: 3,
}

export const MY_VACATION_MODULE_DEPLOY_REQUEST_SUMMARY_DATE = DateTime.fromSQL(
  "2025-06-02"
).set({
  hour: 12,
  millisecond: 0,
  minute: 0,
  second: 0,
})

export const MY_VACATION_REQUEST_FORM_INITIAL_DATA_STATE =
  /** @type {const} */ ({
    requestDates: [
      DateTime.now().set({
        hour: 12,
        millisecond: 0,
        minute: 0,
        second: 0,
      }),
      DateTime.now().set({
        hour: 12,
        millisecond: 0,
        minute: 0,
        second: 0,
      }),
    ],
    bucketDays: 0,
    plusDays: 0,
    accordedDays: 0,
    additionalDays: 0,
    motive: "",
  })

export const MY_VACATION_REQUEST_FORM_INITIAL_VALIDATION_STATE = {
  requestDates: {
    errors: [],
    value: null,
  },
  bucketDays: {
    errors: [],
    value: null,
  },
  plusDays: {
    errors: [],
    value: null,
  },
  accordedDays: {
    errors: [],
    value: null,
  },
  additionalDays: {
    errors: [],
    value: null,
  },
  motive: {
    errors: [],
    value: null,
    typeValidations: [isNotEmpty],
  },
}

export const MY_VACATION_EDIT_APPROVED_FORM_INITIAL_DATA_STATE = {
  requestDates: [
    DateTime.now().set({
      hour: 12,
      millisecond: 0,
      minute: 0,
      second: 0,
    }),
    DateTime.now().set({
      hour: 12,
      millisecond: 0,
      minute: 0,
      second: 0,
    }),
  ],
  bucketDays: 0,
  plusDays: 0,
  accordedDays: 0,
  additionalDays: 0,
  motive: "",
  changeMotive: "",
}

export const MY_VACATION_EDIT_APPROVED_FORM_INITIAL_VALIDATION_STATE = {
  startDate: {
    errors: [],
    value: null,
  },
  endDate: {
    errors: [],
    value: null,
  },
  bucketDays: {
    errors: [],
    value: null,
  },
  plusDays: {
    errors: [],
    value: null,
  },
  accordedDays: {
    errors: [],
    value: null,
  },
  additionalDays: {
    errors: [],
    value: null,
  },
  motive: {
    errors: [],
    value: null,
    typeValidations: [isNotEmpty],
  },
  changeMotive: {
    errors: [],
    value: null,
    typeValidations: [isNotEmpty],
  },
}

export const MY_VACATION_REQUEST_FORM_INITIAL_AVAILABLE_DAYS_LIST = {
  bucketDays: null,
  plusDays: null,
  accordedDays: null,
  additionalDays: null,
}

export const MY_VACATION_REQUEST_FORM_INITIAL_HOLIDAY_LIST = []

export const MY_VACATION_UPDATE_SERVICE_TYPES = {
  PENDING: 0,
  APPROVED: 1,
}

export const GENERIC_SAVE_SUCCESS_MESSAGE = {
  title: "¡Todo bien!",
  message: "Tus cambios se guardaron sin problema.",
}

export const GENERIC_SAVE_ERROR_MESSAGE = {
  title: "¡Ups! Algo salió mal",
  message: "No pudimos completar tu solicitud. Intenta de nuevo en un momento.",
  iconClassName: "my-auto clr-error text-5xl pi-exclamation-circle",
}

export const VACATIONS_SAVE_SUCCESS_MESSAGE = {
  title: "¡Todo bien!",
  message: "Tus cambios se guardaron sin problema.",
}

export const VACATIONS_SAVE_ERROR_MESSAGE = {
  title: "¡Ups! Algo salió mal",
  message: "No pudimos completar tu solicitud. Intenta de nuevo en un momento.",
  iconClassName: "my-auto clr-error text-5xl pi-exclamation-circle",
}

export const VACATIONS_CHANGE_APPROVED_REQUEST_SUCCESS = {
  title: "Solicitud enviada",
  message:
    "Tu petición de cambio de vacaciones ya está en camino, un admin la revisará pronto.",
  icon: "rocket",
}

export const VACATIONS_CHANGE_PENDING_REQUEST_SUCCESS = {
  title: "Solicitud enviada",
  message:
    "Tu petición de cambio de vacaciones ya está en camino, un admin la revisará pronto.",
  icon: "rocket",
}

export const VACATIONS_CANCEL_APPROVED_REQUEST_SUCCESS = {
  title: "Solicitud enviada",
  message:
    "Tu petición de cancelación de vacaciones ya está en camino, un admin la revisará pronto.",
  icon: "rocket",
}

export const VACATIONS_APPROVE_VACATION_REQUEST_SUCCESS = {
  title: "Vacaciones aprobadas",
  message: "Aprobaste la solicitud de vacaciones, hiciste felíz a alguien hoy.",
  iconClassName: "my-auto clr-info text-5xl pi pi-thumbs-up",
}

export const VACATIONS_REJECT_VACATION_REQUEST_SUCCESS = {
  title: "Solicitud rechazada",
  message: "La solicitud se rechazó con éxito, que malo eres...",
  iconClassName: "my-auto clr-info text-5xl pi-thumbs-down",
}

export const VACATIONS_APPROVE_CHANGE_VACATION_REQUEST_SUCCESS = {
  title: "Solicitud aprobada",
  message:
    "Aprobaste la solicitud de cambio de vacaciones, hiciste feliz a alguien hoy.",
  iconClassName: "my-auto clr-info text-5xl pi pi-thumbs-up",
}

export const VACATIONS_REJECT_CHANGE_VACATION_REQUEST_SUCCESS = {
  title: "Solicitud rechazada",
  message: "La solicitud se rechazó con éxito, que malo eres...",
  iconClassName: "my-auto clr-info text-5xl pi pi-thumbs-down",
}

export const VACATIONS_APPROVE_CANCEL_VACATION_REQUEST_SUCCESS = {
  title: "Solicitud aprobada",
  message:
    "Aprobaste la solicitud de cancelación de vacaciones, no te costó trabajo.",
  iconClassName: "my-auto clr-info text-5xl pi pi-thumbs-up",
}

export const VACATIONS_CANCEL_APPROVED_VACATION_REQUEST_SUCCESS = {
  title: "Cancelaste vacaciones",
  message:
    "La cancelación de las vacaciones ya aprobadas se realizó con éxito, no eres malo... eres lo que le sigue.",
  iconClassName: "my-auto clr-info text-5xl pi pi-thumbs-down",
}

export const IDS_HOLIDAY_SCHEMA = {
  MEXICAN_2019: 1,
  MEXICAN_2024: 2,
  INTERNATIONAL: 3,
  GLOBAL: 4,
}

export const VACATION_REQUEST_PLUS_DAYS = {
  OVERDUE: "overdue",
  PROGRAMMED: "programmed",
  CURRENT: "current",
}
